import Loader from './Loader/Loader_component';

export default {
  Loader
}



// WEBPACK FOOTER //
// ./common/components/index.js